<template>
	<div >
    <!--<div class="gPageBorder">-->
		  <!--<el-row>-->
        <!--<el-col :span="24">-->
          <!--<el-form ref="addForm" class='gForm' id="addForm" :model="form" label-width="12.5%">-->
            <!--<el-form-item :label="$t('lin_global.xzbbbbb')">-->
                <!--<el-select filterable clearable v-model="form.ota_rom_id" @change="otaEvent" style="width:100%">-->
                   <!--<el-option v-for="item in arrdata" :label="item.name" :value="item.id">-->
                   <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item :label="$t('lin_global.zhidingqdsxx')">-->
              <!--<el-input v-model="form.memo" :readonly="true"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item :label="$t('lin_global.tslxxx')">-->
                <!--<el-select @change="changeType" filterable  v-model="form.type" style="width:100%">-->
                   <!--<el-option v-for="item in type" :label="item.typename" :value="item.typeid">-->
                   <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item v-if="form.type === '0'" :label="$t('lin_global.label_areaid')">-->
                <!--&lt;!&ndash;<el-select filterable clearable v-model="form.targetId" :placeholder="$t('lin_global.place_areaid')" style="width:100%">&ndash;&gt;-->
                   <!--&lt;!&ndash;<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">&ndash;&gt;-->
                   <!--&lt;!&ndash;</el-option>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-select>&ndash;&gt;-->
              <!--<MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>-->
            <!--</el-form-item>-->
		        <!--<el-form-item v-if="form.type === '1'" :label="$t('lin_global.label_no')">-->
              <!--&lt;!&ndash; <el-input v-model="form.targetId"></el-input> &ndash;&gt;-->
              <!--<AutoTerno @on-result-change="onDvInputChange"></AutoTerno>-->
            <!--</el-form-item>-->
            <!--<el-form-item v-if="form.type === '2'" :label="$t('app_mdFile')">-->

                <!--<a class='aSc' style='' :href="downUrl" :title="$t('app_downExp')" target="_blank">-->
                  <!--{{$t('app_downTplFile')}}-->
                <!--</a>-->

                <!--<el-upload-->
                <!--ref="upload"-->
                <!--class="upload-demo"-->
                <!--name='fileUpload'-->
                <!--:action="fileUploadUrl"-->
                <!--:before-upload="srcBefore"-->
                <!--:on-success="srcSuccess"-->
                <!--:file-list="srcList">-->
                <!--<el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>-->
               <!--</el-upload>-->

            <!--</el-form-item>-->
            <!--<el-form-item v-if="form.type === '2'"  :label="$t('app_deviceNum')">-->
              <!--<label>{{dvNum}}{{$t('app_amechine')}}</label>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
              <!--&lt;!&ndash; <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button> &ndash;&gt;-->
              <!--<el-button type="primary" :loading="addLoading" @click="onSubmit">{{$t('lin_btn.add')}}</el-button>-->
            <!--</el-form-item>-->

          <!--</el-form>-->
        <!--</el-col>-->
      <!--</el-row>-->
    <!--</div>-->

    <div class="gTopMg gPageBorder" v-loading='hLoading'>
      <el-table
        :data="arrdata"
        border
        style="width: 100%"
        ref="arrdata">
        <el-table-column
          prop="name"
          :label="$t('lin_global.name')">
        </el-table-column>
        <el-table-column
          prop="version"
          :label="$t('lin_global.version')"
          width="120">
        </el-table-column>
        <!--<el-table-column
              prop="status"
              label="状态"
              width="150"
              :formatter="formatStatus">
              </el-table-column>-->
        <el-table-column
          :label="$t('lin_global.status')"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="color: #8492A6;">{{$t('lin_global.waitOne')}}</span>
            <span v-if="scope.row.status == 1" style="color: #F7BA2A;">{{$t('lin_global.waitTwo')}}</span>
            <span v-if="scope.row.status == 2" style="color:#13CE66;">{{$t('lin_global.verifyPass')}}</span>
            <span v-if="scope.row.status == 3" style="color: #FF4949;">{{$t('lin_global.verifyNotPass')}}</span>
            <el-popover v-if="scope.row.ifInfor" trigger="hover" placement="top">
              <p>{{ scope.row.auditContent }}</p>
              <span slot="reference" class="name-wrapper">
              <el-icon style="cursor: pointer;color: #58B7FF;" v-if="scope.row.ifInfor" name="information"></el-icon>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('terminal.details.animatType')"
          width="100">
          <template slot-scope='scope'>
            <label>{{otaUdType(scope.row.updateType)}}</label>
          </template>
        </el-table-column>
        <el-table-column
          prop="mechanismName"
          :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
          prop="size"
          :label="$t('app_fileSize')"
          width="100">
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="md5"-->
          <!--label="MD5"-->
          <!--width="200">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="download"-->
          <!--:label="$t('lin_global.downNumber')"-->
          <!--width="100">-->
        <!--</el-table-column>-->
        <el-table-column
          align='center'
          :label="$t('lin_global.ope')" width="106">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.submit" @click="submitRow(scope.row.id)" type="text">{{$t('lin_global.smVerify')}}</el-button> -->
            <!--<el-tooltip class="item" effect="dark" :content="$t('lin_global.smVerify')" placement="top">-->
              <!--<el-button type='text' v-if="scope.row.submit" @click="submitRow(scope.row.id)"><i class="fa fa-external-link-square" style=""></i></el-button>-->
            <!--</el-tooltip>-->

            <!--&lt;!&ndash; <el-button v-if="scope.row.edit" @click="editRow(scope.row.id)" type="text">{{$t('lin_btn.edit')}}</el-button> &ndash;&gt;-->
            <!--<el-tooltip class="item" effect="dark" :content="$t('lin_btn.edit')" placement="top">-->
              <!--<el-button type='text' v-if="scope.row.edit" @click="editRow(scope.row.id)"><i class="fa fa-pencil-square" style=""></i></el-button>-->
            <!--</el-tooltip>-->

            
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='push(scope.row)'><i class="fa fa-upload" style="color:#20A0FF"></i></el-button>
            </el-tooltip> -->


            <!--&lt;!&ndash; <el-button v-if="scope.row.delete" @click="deleteRow(scope.row.id)" type="text">{{$t('lin_btn.delete')}}</el-button> &ndash;&gt;-->
            <!--<el-tooltip class="item" effect="dark" :content="$t('lin_btn.delete')" placement="top">-->
              <!--<el-button type='text' v-if="scope.row.delete" @click="deleteRow(scope.row.id)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>-->
            <!--</el-tooltip>-->
          </template>
        </el-table-column>
      </el-table>
      <!--<p class='gPTitle'>{{$t('app_operateHis')}}</p>-->
      <!--<el-table :data="arrdatas" border>-->
        <!--<el-table-column-->
          <!--prop="opeTime"-->
          <!--:label="$t('lin_global.time')">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="mechanismName"-->
          <!--:label="$t('lin_global.label_areaid')">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="pushType"-->
          <!--:label="$t('lin_global.tuisongleixing')"-->
        <!--:formatter="formatStatus">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="successNums"-->
          <!--:label="$t('lin_global.chenggong')">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="failNums"-->
          <!--:label="$t('lin_global.shibai')">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--width='80'-->
          <!--align='center'-->
          <!--:label="$t('lin_global.ope')">-->
          <!--<template slot-scope="scope">-->
            <!--&lt;!&ndash; <el-button v-if="scope.row.failNum > 0" @click.stop="resXiafa(scope.row.pushType,scope.row.mechId)" type="text">{{$t('lin_global.chongxintuisong')}}</el-button> &ndash;&gt;-->
            <!--<el-tooltip class="item" effect="dark" :content="$t('lin_global.chongxintuisong')" placement="top">-->
              <!--<el-button type='text' v-if="scope.row.failNums > 0" @click.stop="resXiafa(scope.row)"><i class="fa fa-upload" style=""></i></el-button>-->
            <!--</el-tooltip>-->

          <!--</template>-->
        <!--</el-table-column>-->
      <!--</el-table>-->
      <div class='gPgDiv'>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
          class="gPg">
          </el-pagination>
      </div>
    </div>


    </div>
	</div>
</template>
<script>
  import AutoTerno from '../global/TernoAutoCtrl'
	import axios from 'axios'
    import { baseurl } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector, AutoTerno
    },
		data(){
      var that = this
			return{
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.targetId = value
//            that.cSelect(value)
          }
        },
        dvNum: 0,
        hLoading: false,
        srcList: [],
				isShow:true,
				arrdata:[],
        exInfo: {},
				form:{
					token:localStorage.getItem('user'),
					memo:'',
					type:'0',
					targetId:'',
					ota_rom_id:'',
          fileNo: ''
				},
				areaList:[],
				type:[{
					typename:this.$t('lin_global.label_areaid'),
					typeid:'0'
				},{
					typename:this.$t('lin_global.shebei'),
					typeid	:'1'
				},{
          typename:this.$t('app_fileImport'),
          typeid  :'2'
        }],
        otaObject:[],
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
        arrdatas:[],
        addLoading:false
			}
		},
    watch : {
		  'form.type' (val) {
		    console.log("type:" + val)
      }
    },
    computed: {
      fileUploadUrl () {
        return this.$fileExcelUlUrl
      },
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      }
    },
		created(){
			this.getAd();
      this.getData();
		},
		methods:{
		  push (row) {
        this.$setWObj('otaPushInfo', row)
        // this.$router.push({name: this.$t('menu.sysManageSub.pushHistory')})
      },
      otaUdType (key) {
        var vls = {'0': this.$t('app_ttPkg'), '1': this.$t('app_dfPkg')}
        return vls[key]
      },
      onDvInputChange (vl) {
        this.form.targetId = vl
      },
      srcBefore (file) {
        // console.log(file)
        window[this.$route.path] = 1
        /*var name = file.name
        if (name === 'part0.zip') {
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } */
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        //console.log('exres', res)
        if (res.status === 200) {
          this.srcList = [{name: file.name}]
          this.exInfo = res.data
          this.exInfo.file = file.name
          this.form.fileNo = res.data.fileNo
          //this.hBlur('fm')
          this.dvNum = res.data.terNums
        } else {
          if (this.exInfo.file) {
            this.srcList = [{name: this.exInfo.file}]
          } else {
            this.srcList = []
          }
          this.$message.error(res.message)
        }
      },
      resXiafa:function(row){
        //console.log(row)
        this.hLoading = true
        this.$repush(row.pushType, row.opeTime, row.objectId, (res) => {
          this.hLoading = false
          if(res.status == 200){
            this.$message.success(res.message);
            this.getList(1,this.form.ota_rom_id);
          }else{
            this.$message.error(res.message)
          }
        }, (error) => {
          this.hLoading = false
          this.$message.error(this.$t('app_rqsError'))
        })

        /*var params = {
          type:a,
          mechId:b,
          ota_rom_id:this.form.ota_rom_id
        }
        axios.post(`${baseurl}/ota_rom/re_push.do`,params).then(res=>{
          if(res.data.status == 200){
            this.$message.success(res.data.message);
            this.getList(1,this.form.ota_rom_id);
          }else{
            this.$message.error(res.data.message)
          }
        })*/
      },
      formatStatus:function(row){
          return row.pushType == 0?"渠道商":"设备";
      },
      getList:function(page,id){
        this.currentPage = page;
        this.hLoading = true
        //var params = {ota_rom_id:id,page:page,rows:this.pageSize}
        this.$pushRecords(page, this.$gRow, '2', id, (res) => {
          this.hLoading = false
          if(res.status == 200){
            //console.log(res.data)
            this.arrdatas = res.data;
            this.totalRecords = res.total;
          }else{
            this.$message.error(res.message)
          }
        }, (error) => {
          this.hLoading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      handleSizeChange: function (val) {
        this.pageSize = val
        this.getList(this.currentPage,this.form.ota_rom_id)

      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        this.getList(this.currentPage,this.form.ota_rom_id)

      },
      otaEvent:function(val){
          for(var i=0;i<this.arrdata.length;i++){
              if(val == this.arrdata[i].id){
                this.otaObject.push(this.arrdata[i]);
                if(this.arrdata[i].mechanismName){
                  this.form.memo = this.arrdata[i].mechanismName
                }else{
                  this.form.memo = this.$t('lin_global.null')
                }

              }
          }

          this.getList(this.currentPage,val)

      },
			onSubmit:function(){

				var params = this.form;
				//console.log("打印传入参数");
				console.log(params)

        if (!params.ota_rom_id) {
          this.$message.error(this.$t('app_inputCp'))
          return
        }
        switch(params.type) {
          case '0':
          case '1':
            if (!params.targetId) {
              this.$message.error(this.$t('app_inputCp'))
              return
            }
          break
          case '2':
            if (!params.fileNo) {
              this.$message.error(this.$t('app_inputCp'))
              return
            }
            break
        }

        this.addLoading = true;
				axios.post(`${baseurl}/ota_rom/push.do`,params).then(res=>{
					//console.log("打印返回数据");
					//console.log(res.data)
		            if(res.data.status == 200){
		            	this.$message(res.data.message);
                  this.addLoading = false;
                  this.getList(1,this.form.ota_rom_id)
                  if (this.$refs.upload) {
                    this.$refs.upload.clearFiles()
                  }
		            }else{
		            	this.$message.error(res.data.message)
                  this.addLoading = false;
		            }
        }).catch((error)=> {
          this.$message.error(error);
          this.addLoading = false;
        })
			},
			changeType:function(){
			    this.form.targetId = '';
				if(this.form.type == '0'){
					this.isShow = true
				}else{
					this.isShow = false
				}
			},
			getData:function(){
			  let that = this
				var params = {page:1,rows:100000,type:'',name:'',status:'2'};
				//console.log("看看是何方参数");
				//console.log(params);
				axios.post(`${baseurl}/ota_rom/list.do`,params).then(res=>{
					//console.log("打印返回ORM列表")
//					console.log(res.data.data);
          that.totalRecords = res.data.total
					this.arrdata = res.data.data;
				})
			},
			getAd:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		/*var obj={
		    			'mechanismname':'所有渠道商通用',
		    			'mechanismid':''
		    		}*/
		    		this.areaList = res.data.data;

		    		//this.areaList.unshift(obj)
		    	})
		    },

			onCancel:function(){
				this.$router.go(-1);
			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// romPush.vue?5e7bdb33